import React from 'react';
import { AppProvider } from './context/AppContext';
import Routes from './routes';
import GlobalStyle from './styles/global';
import './styles/index.css';


function App() {
  return (
    <AppProvider>
      <GlobalStyle />
      <Routes />
    </AppProvider>
  );
}

export default App;
